import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudCheck"><Path d="M4.79793 19.14C2.86509 18.3483 1.5 16.4159 1.5 14.1577C1.5 11.4399 3.47732 9.19405 6.04196 8.8407C6.89331 6.31478 9.23929 4.5 12 4.5C14.7607 4.5 17.1067 6.31478 17.958 8.8407C20.5227 9.19405 22.5 11.4399 22.5 14.1577C22.5 16.4159 21.1349 18.3483 19.2021 19.14" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 17L11.1667 20L16.5 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloudCheck;
